import React from 'react';
import styles from '../styles/LandingPage.module.css';

const HowItWorksSection = () => {
  return (
    <section className={styles.howItWorksSection}>
      <div className={styles.container}>
        <div className={styles.sectionHeader}>
          <h2>How It Works</h2>
          <p>Get started in 3 simple steps</p>
        </div>
        
        <div className={styles.stepsGrid}>
          <div className={styles.stepCard}>
            <div className={styles.stepNumber}>1</div>
            <h3>Add Your Stocks</h3>
            <p>Enter your stock purchases with price, quantity, and date. Organize by sectors.</p>
            <div className={styles.stepVisual}>
              <div className={styles.addStockForm}>
                <div className={styles.formField}>
                  <span>Stock Name</span>
                  <div className={styles.input}>RELIANCE</div>
                </div>
                <div className={styles.formField}>
                  <span>Quantity</span>
                  <div className={styles.input}>100</div>
                </div>
                <div className={styles.formField}>
                  <span>Price</span>
                  <div className={styles.input}>₹2,450</div>
                </div>
              </div>
            </div>
          </div>
          
          <div className={styles.stepCard}>
            <div className={styles.stepNumber}>2</div>
            <h3>Track Performance</h3>
            <p>Monitor your portfolio with live prices, P&L calculations, and sector analytics.</p>
            <div className={styles.stepVisual}>
              <div className={styles.performanceCard}>
                <div className={styles.performanceHeader}>
                  <span>Portfolio Value</span>
                  <span className={styles.liveBadge}>LIVE</span>
                </div>
                <div className={styles.performanceValue}>₹5,89,500</div>
                <div className={styles.performanceChange}>+₹64,500 (+12.3%)</div>
              </div>
            </div>
          </div>
          
          <div className={styles.stepCard}>
            <div className={styles.stepNumber}>3</div>
            <h3>Analyze & Export</h3>
            <p>View detailed analytics, charts, and export your data for external analysis.</p>
            <div className={styles.stepVisual}>
              <div className={styles.analyticsPreview}>
                <div className={styles.chartPlaceholder}>
                  <div className={styles.chartBar} style={{height: '70%'}}></div>
                  <div className={styles.chartBar} style={{height: '50%'}}></div>
                  <div className={styles.chartBar} style={{height: '90%'}}></div>
                  <div className={styles.chartBar} style={{height: '30%'}}></div>
                </div>
                <div className={styles.exportButton}>Export CSV</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;